import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Modal, Row, Col, Spinner } from "react-bootstrap";
import TabellaLista from '../../../../components/Tabella/TabellaLista';
import { ChipFilter, filtroMultiplo } from '../../../../components/Tabella/ChipFilter';
import MyApiClient from '../../../../../api-client/MyApiClient';
import DEFAULT_STRUTTURA from "../../../../../images/DEFAULT_STRUTTURA.png";

// Valori del filtro a chip, come compaiono nella lista.
const STATO_OPTIONS = ['In attesa', 'Confermato', 'Rifiutato', 'Non configurato'];

const BillingRequests = () => {
	const navigate = useNavigate();

	const [data_json, setDataJson] = useState(null);
	// Chip a scelta multipla: all'inizio tutti accesi
	const [statoFilter, setStatoFilter] = useState(STATO_OPTIONS);

	const filteredData = useMemo(
		() =>
			data_json &&
			data_json.filter((row) => filtroMultiplo(statoFilter, STATO_OPTIONS, row.status_label?.label)),
		[data_json, statoFilter],
	);

	const [modalShowed, setModalShowed] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalText, setModalText] = useState('');

	const [loadingShowed, setLoadingShowed] = useState(false);

	const data_column = [
		{
			Header: 'Struttura',
			accessor: 'clubName',
			Cell: ({ row }) => {
				return (
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<img
							src={row.original.imageUrlClub ? row.original.imageUrlClub : DEFAULT_STRUTTURA}
							alt={row.original.clubName}
							style={{
								width: '40px',
								height: '40px',
								borderRadius: '50%',
								marginRight: '10px'
							}}
						/>
						<div>
							{row.original.clubName}
						</div>
					</div>
				)
			}
		},
		{
			Header: 'Email',
			accessor: 'email',
		},
		{
			Header: 'Telefono',
			accessor: 'phoneNumber',
		},
		{
			Header: 'Stato',
			Footer: 'Stato',
			accessor: 'status_label',
			disableGlobalFilter: true,
			Cell: ({ value }) => {
				return (
					<div className="d-flex align-items-center">
						<i className={`fa fa-circle me-1 ${value?value.class:''}`}></i>
						{value?value.label:''}
					</div>
				)
			},
		},
	];

	function openDetail(row) {
		navigate('/superadmin/anagrafiche/strutture-sportive/'+row.id);
	}
	
	useEffect(() => {
		const fetchData = async () => {
			try {
				const tokenDetailsString = sessionStorage.getItem('userDetails');
				if (tokenDetailsString) {
					const tokenDetails = JSON.parse(tokenDetailsString);
					let token = tokenDetails.idToken;
					const apiClient = new MyApiClient();

					setLoadingShowed(true);
					const requests = await apiClient.getClubInvoiceDataSenders(token);
					setLoadingShowed(false);

					if(requests && !requests.error) {
						let data = [];
						requests.forEach(element => {

							let imageClub = null;
                            if(element.logo) {
								imageClub = element.logo;
							}

							let status = null;
                            const invoiceStatus = element.invoiceDataSender ? element.invoiceDataSender.status : 'NOT_CONFIGURED';

							if(invoiceStatus === 'CONFIRMED') {
								status = {
									"label": "Confermato",
									"class": "text-success"
								};
							} else if(invoiceStatus === 'WAIT_RESPONSE') {
								status = {
									"label": "In attesa",
									"class": "text-warning"
								};
							} else if(invoiceStatus === 'REJECTED') {
								status = {
									"label": "Rifiutato",
									"class": "text-danger"
								};
							} else {
								status = {
									"label": "Non configurato",
									"class": "text-muted"
								};
							}

							let row = {
								"id": element.userId,
								"clubName": element.name,
                                "email": element.email,
                                "phoneNumber": element.phoneNumber,
								"status": invoiceStatus,
								"status_label": status,
								"imageUrlClub": imageClub,
							};
							data.push(row);
							
						});
						setDataJson(data);
					}
				}
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		};

		fetchData();

	}, []);

	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<Modal className="fade" show={modalShowed} centered>
				<Modal.Header>
					<Modal.Title>{modalTitle}</Modal.Title>
					<Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
					</Button>
				</Modal.Header>
				<Modal.Body>
					<Row><Col className="col-xl-64">{modalText}</Col></Row>
				</Modal.Body>
				<Modal.Footer className="justify-content-between">
					<Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
						Chiudi
					</Button>
				</Modal.Footer>
			</Modal>

			<TabellaLista
				openColumn={'clubName'}
				openRow={(row) => openDetail(row)}
				cardTitle={'Richieste di abilitazione a fatture e ricevute'}
				pageList={true}
				hasSearch={true}
				searchPlaceholder={'Cerca per struttura, email o telefono'}
				hasFilter={false}
				filterControl={
					<div className="sid-chip-filters">
						<ChipFilter label="Stato" options={STATO_OPTIONS} value={statoFilter} onChange={setStatoFilter} multiple />
					</div>
				}
				data_column={data_column}
				data_json={filteredData}
				modalCallBack={() => setModalShowed(true)}
				sort_by={'clubName'}
                sort_type={'asc'}
			/>
		</>
	)
}
export default BillingRequests;